<template>
  <div class="countries">
    <toolbar
      backRoute="/dashboard"
      title="Countries"
      :addButton="true"
      addButtonLabel="Add country"
      addButtonRoute="/dashboard/countries/new" />

    <d-row class="mt-5">
      <d-col cols="12" class="d-flex">
        <d-input
          v-model="filters.search"
          placeholder="Search countries"
          @keyup.native.enter="saveFilters" />
        <d-button
          theme="primary"
          outline
          class="ml-2"
          @click.prevent="saveFilters">
          Search
        </d-button>
        <d-button
          v-if="filters.search !== ''"
          theme="danger"
          outline
          class="ml-2"
          @click.prevent="resetFilters">
          Reset
        </d-button>
      </d-col>
    </d-row>

    <table class="table table-striped table-bordered table-hover mt-5">
      <thead>
        <tr>
          <sortable-table-heading field="name" view="countries" :column="orderColumn" :direction="orderDirection">Name</sortable-table-heading>
          <th>Useful links</th>
          <sortable-table-heading field="warnings_count" view="countries" :column="orderColumn" :direction="orderDirection">Warnings</sortable-table-heading>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody v-if="!loadError">
        <tr v-if="!allDataLoaded">
          <td
            colspan="6"
            class="text-center">
            Loading countries&hellip;
          </td>
        </tr>
        <tr v-if="allDataLoaded && countries.length === 0">
            <td
              colspan="6"
              class="text-center">
              There are no countries to display&hellip;
            </td>
          </tr>
        <tr
          v-for="(country, index) of countries"
          :key="'country-' + index">
          <td class="align-middle">{{ country.name }}</td>
          <td class="align-middle" style="width: 240px;">
            <a
              v-if="country.url_vaccination_inf"
              :href="country.url_vaccination_inf"
              target="_blank"
              rel="noopener noreferrer">
              <i class="material-icons">info</i>
              Vaccination information
            </a><br>

            <a
              v-if="country.url_more_country"
              :href="country.url_more_country"
              target="_blank"
              rel="noopener noreferrer">
              <i class="material-icons">info</i>
              More country information
            </a>
          </td>
          <td class="align-middle text-center" style="width: 160px;">
            <span class="text-warning" v-if="country.warnings_count > 0">{{ country.warnings_count }}</span>
            <span class="text-light" v-else>{{ country.warnings_count }}</span>
          </td>
          <td class="align-middle" style="width: 70px;">
            <d-button
              theme="primary"
              @click.native="$router.push('/dashboard/countries/' + country.id)"
              class="mr-2"
              title="Edit country">
              <i class="material-icons">search</i>
            </d-button>
          </td>
        </tr>
      </tbody>
    </table>

    <d-alert
      v-if="loadError"
      show
      theme="warning">
      An error occurred during data loading. <a href="javascript:window.location.reload();" class="alert-link">Reload the page</a> to try again.
    </d-alert>

    <pagination :meta-data="paginationMetaData" />
  </div>
</template>

<script>
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';
import SortableTableHeading from './../components/common/SortableTableHeading.vue';

export default {
  name: 'countries',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination,
    'sortable-table-heading': SortableTableHeading
  },
  computed: {
    allDataLoaded () {
      return this.loaded;
    }
  },
  data () {
    return {
      loaded: false,
      countries: null,
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadFilteredData();
  },
  methods: {
    removeCountry (countryID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/countries/delete/',
        id: countryID,
        successTitle: 'Country removed',
        successText: 'The selected country has been removed',
        confirmTitle: 'Do you really want to remove this country?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
          this.$bus.$emit('countries-list-reload');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

<style lang="scss">

</style>
